<template>
  <div style="background: #f4f6f8;min-height: 100%;">
    <div ref="header" class="header">
      <nav-bar>我的优惠券</nav-bar>
      <div class="nav-tab">
        <div
          class="nav-tab-item"
          :class="{ active: useState === IS_USED.NOT_USE }"
          @click="changeUseState(IS_USED.NOT_USE)"
        >
          未使用
        </div>
        <div
          class="nav-tab-item"
          :class="{ active: useState === IS_USED.USED }"
          @click="changeUseState(IS_USED.USED)"
        >
          已失效
        </div>
      </div>
    </div>
    <cll-state-view :loading="loading">
      <div
        class="content"
        :style="{
          paddingTop: `${marginTop}px`,
          height: `${height}px`,
          paddingBottom: `${paddingBottom}px`
        }"
      >
        <div
          class="list-wrapper"
          v-show="useState === IS_USED.NOT_USE && list.length"
        >
          <coupon-card
            v-for="(coupon, index) in list"
            :key="`card-${index}`"
            :data-source="coupon"
            :active="activeCouponId"
            @on-click="updateCoupons"
          />
          <cll-load-more
            v-show="hasNextPage[useState]"
            :loading="loadingMore"
            @load-more="loadMore"
          ></cll-load-more>
        </div>
        <div
          class="list-wrapper"
          v-show="useState === IS_USED.USED && usedList.length"
        >
          <coupon-card
            v-for="(coupon, index) in usedList"
            :key="`card-${index}`"
            :data-source="coupon"
            :disabled="true"
          />
          <cll-load-more
            v-show="hasNextPage[useState]"
            :loading="loadingMore"
            @load-more="loadMore"
          ></cll-load-more>
        </div>
        <div
          class="blank"
          v-show="!loading"
          v-if="
            (useState === IS_USED.NOT_USE && list.length === 0) ||
              (useState === IS_USED.USED && usedList.length === 0)
          "
        >
          <img src="./assets/blank.png" alt="" class="blank-image" />
          <div class="blank-text">
            暂无优惠券
          </div>
        </div>
      </div>
    </cll-state-view>
  </div>
</template>

<script>
import NavBar from '../../components/nav-bar/index'
import CllStateView from '../../components/cll-state-view/index.vue'
import CouponCard from './components/coupon-card'
import api from './api/coupons'
import CllLoadMore from '../../components/cll-load-more/index.vue'

const IS_USED = {
  NOT_USE: 0,
  USED: 1
}

const PAGE_SIZE = 1000

export default {
  name: 'CouponsView',
  components: { CllLoadMore, CouponCard, CllStateView, NavBar },
  data() {
    return {
      IS_USED,
      windowHeight: 500,
      marginTop: 50,
      height: 500,
      w: 0,
      h: 0,
      dd: false,
      list: [],
      usedList: [],
      activeCouponId: null,
      userId: '',
      cityId: '',
      useState: IS_USED.NOT_USE,
      loading: false,
      hasNextPage: {
        0: false,
        1: false
      },
      currentPage: {
        0: 1,
        1: 1
      },
      loadingMore: false
    }
  },
  watch: {
    useState() {
      this.getList()
    }
  },
  mounted() {
    this.userId = this.$UserService.getUserId()
    this.cityId = this.$AppService.getCityId()
    this.getList()
    this.$nextTick(() => {
      this.calcHeight()
    })
  },
  activated() {
    this.getList()
    this.$nextTick(() => {
      this.calcHeight()
    })
  },
  methods: {
    getList() {
      this.loading = true
      api
        .list({
          bigCityId: this.cityId,
          cityId: this.cityId,
          userId: this.userId,
          isUsed: this.useState,
          currentPage: this.currentPage[this.useState],
          pageSize: PAGE_SIZE
        })
        .then(data => {
          const { list, hasNextPage, pageNum } = data
          this[this.useState === IS_USED.NOT_USE ? 'list' : 'usedList'] = list
          this.hasNextPage = Object.assign({}, this.hasNextPage, {
            [this.useState]: hasNextPage
          })
          this.currentPage = Object.assign({}, this.currentPage, {
            [this.useState]: pageNum
          })
        })
        .catch(res => {
          this.$toast(res.msg)
        })
        .finally(() => {
          this.loading = false
          this.$nextTick(() => {
            this.calcHeight()
          })
        })
    },
    loadMore() {
      this.currentPage = Object.assign({}, this.currentPage, {
        [this.useState]: this.currentPage[this.useState] + 1
      })
      this.loadingMore = true
      api
        .list({
          cityId: this.cityId,
          userId: this.userId,
          isUsed: this.useState,
          currentPage: this.currentPage[this.useState],
          pageSize: PAGE_SIZE
        })
        .then(data => {
          const { list, hasNextPage, pageNum } = data
          const prev = this[
            this.useState === IS_USED.NOT_USE ? 'list' : 'usedList'
          ]
          this[
            this.useState === IS_USED.NOT_USE ? 'list' : 'usedList'
          ] = prev.concat(list)
          this.hasNextPage = Object.assign({}, this.hasNextPage, {
            [this.useState]: hasNextPage
          })
          this.currentPage = Object.assign({}, this.currentPage, {
            [this.useState]: pageNum
          })
        })
        .catch(res => {
          this.$toast(res.msg)
        })
        .finally(() => {
          this.loadingMore = false
        })
    },
    // 计算滚动区域高度
    calcHeight() {
      try {
        this.windowHeight = document.documentElement.clientHeight
        this.marginTop = this.$refs.header.clientHeight
        this.paddingBottom = 0
        this.height = document.documentElement.clientHeight
      } catch (e) {
        console.log(e)
      }
    },
    updateCoupons(id) {
      this.activeCouponId = null
      this.$nextTick(() => {
        this.activeCouponId = id
      })
    },
    changeUseState(state) {
      this.useState = state
    }
  }
}
</script>

<style scoped>
.header {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: #ffffff;
  z-index: 10000;
}

.nav-tab {
  height: 48px;
  display: flex;
}

.nav-tab-item {
  flex: 1;
  position: relative;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #000000;
  line-height: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.nav-tab-item.active {
  font-weight: 500;
  color: #006EFA;
}

.nav-tab-item.active:after {
  content: '';
  display: block;
  width: 48px;
  height: 2px;
  background: #006EFA;
  position: absolute;
  bottom: 7px;
}

.list-wrapper {
  padding: 10px;
  position: relative;
}

.content {
  position: relative;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  background: #F3F4F5;
  overflow-y: scroll;
}

.blank {
  width: 112px;
  height: 112px;
  text-align: center;
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -56px;
  margin-left: -56px;
  z-index: 999;
}

.blank-image {
  width: 80px;
  height: 80px;
}

.blank-text {
  font-size: 14px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 20px;
}
</style>
